import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export function Resume({ resumen = '', onUpdate }) {
   const [resumeModalOpen, setResumeModalOpen] = useState(false);
   const [resumenText, setResumenText] = useState(resumen);

   // Actualizar el estado local cuando cambia la prop
   React.useEffect(() => {
      setResumenText(resumen);
   }, [resumen]);

   const handleSave = () => {
      if (onUpdate) {
         onUpdate(resumenText);
      }
      setResumeModalOpen(false);
   };

   return <div id="resume_headline_bx" className=" job-bx bg-white m-b30">
      <Modal show={resumeModalOpen} onHide={() => setResumeModalOpen(false)} className="modal fade modal-bx-info editor">
         <div className="modal-dialog my-0" role="document">
            <div className="modal-content">
               <div className="modal-header">
                  <h5 className="modal-title" id="ResumeheadlineModalLongTitle">Resumen</h5>
                  <button type="button" className="close" onClick={() => setResumeModalOpen(false)}>
                     <span aria-hidden="true">&times;</span>
                  </button>
               </div>
               <div className="modal-body">
                  <p>Es lo primero que notan los reclutadores en tu perfil. Escribe de manera concisa qué te hace la persona única y adecuada para el trabajo que estás buscando.</p>
                  <p>Su resumen de perfil debe mencionar los aspectos más destacados de su carrera y educación, cuáles son sus intereses profesionales y qué tipo de carrera está buscando.</p>
                  <p>Escriba un resumen significativo de más de 50 caracteres</p>
                  <form>
                     <div className="row">
                        <div className="col-lg-12 col-md-12">
                           <div className="form-group">
                              <textarea 
                                 className="form-control" 
                                 placeholder="Escribe tu resumen descriptivo"
                                 value={resumenText}
                                 onChange={(e) => setResumenText(e.target.value)}
                                 rows="5"
                              ></textarea>
                           </div>
                        </div>
                     </div>
                  </form>
               </div>
               <div className="modal-footer">
                  <button type="button" className="site-button" onClick={() => setResumeModalOpen(false)}>Cancelar</button>
                  <button type="button" className="site-button" onClick={handleSave}>Guardar</button>
               </div>
            </div>
         </div>
      </Modal>
      <div className="d-flex">
         <h5 className="m-b15">Resumen</h5>
         <Link to={"#"} className="site-button add-btn button-sm" onClick={() => setResumeModalOpen(true)}>
            <i className="fa fa-pencil m-r5"></i> Editar
         </Link>
      </div>
      <p className="m-b0">{resumen || 'No has agregado un resumen aún. Haz clic en Editar para agregar uno.'}</p>
   </div>
}